import { ReportExportListFilters } from 'src/features/reportExport/list/filters/useReportExportListFilters'
import { queryKeyPrefix } from 'src/features/tanStackQuery/queryKeyPrefix'

const prefix = queryKeyPrefix.reportExportList

export const queryKeys = {
  all: [...prefix] as const,
  reportExports: (filters: ReportExportListFilters) =>
    [...prefix, 'reportExports', filters] as const,
}
